export default {
  SET_PRODUCTS (state, products) {
    state.products = products
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.products.findIndex((u) => u.id === itemId)
    state.products.splice(roleIndex, 1)
  }
}
